function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('.product-recommendations-placeholder .product-recommendations').then((elm) => {
    $('.product-recommendations .product-single__related').slick('unslick');
    
    $('.product-recommendations .product-single__related').slick({
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                arrows: false
            }
        }]
    });
    const buttonATC =  document.querySelectorAll('.button-ATC')
    buttonATC.forEach((button) => {
        button.addEventListener('click', (e) => {
        e.stopPropagation()
        })
    })

    $('.modal__product-images--slider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false
    });

    function resizeSlider() {
        $('.modal__product-images--slider').slick('refresh');
    }
    
    $('.quick-product__btn').on('click', resizeSlider);

    // Quick View Modal Add to Cart Handler

    let id;

    const formData = {
        items: [
            {
                id,
                quantity: 1,
            },
        ],
    };

    $('.quick-product__btn').on('click', function() {
        setTimeout(() => {
            formData.items[0].id = document.querySelector('.modal--square.modal--quick-shop.modal--is-active .product-single__variants')?.value;
        }, 500);
    });

    $('.modal--square.modal--quick-shop .variant-input label').on('click', function(e) {
        let priceWrapper = e.target.closest('.modal--square.modal--quick-shop .product-single__meta').querySelector('.product-single__price');
        let selectedVariantPrice = e.target.closest('.variant-input').querySelector('input').dataset.variantPrice;
        let selectedVariantId = e.target.closest('.variant-input').querySelector('input').dataset.variantId;

        priceWrapper.innerHTML = `<span class='product__price'>${selectedVariantPrice}<span>`;

        formData.items[0].id = selectedVariantId;
    });
    $('.modal--square.modal--quick-shop .add-to-cart').on('click', function(event){
        event.preventDefault();

        theme.cart.addItemFromForm(formData).then(() => {
            theme.cart.getCart().then(function(cart) {
                theme.CartDrawer.prototype.status={
                    loaded: false,
                    loading: false
                };
                var source=$('#CartTemplate').html();
                theme.CartDrawer.prototype.template = Handlebars.compile(source);
                theme.CartDrawer.prototype.buildCart(cart);
                $('a.js-drawer-open-cart').click();
            });
        });
    });
});